export default __webpack_public_path__ + "static/media/M04.ede65fea.svg";